<template>
  <generic-list v-bind="{ model, modelHeaders, filters }">
    <template v-slot:item.is_rentable="{ item }">
      <v-simple-checkbox
        v-model="item.is_rentable"
        disabled
      ></v-simple-checkbox>
    </template>

    <template v-slot:item.is_cumbersome="{ item }">
      <v-simple-checkbox
        v-model="item.is_cumbersome"
        disabled
      ></v-simple-checkbox>
    </template>
  </generic-list>
</template>

<script>
import models from "@/models"

export default {
  name: "List",
  data() {
    return {
      model: models.Instrument,
      modelHeaders: [
        { text: "Nome", value: "name" },
        { text: "Noleggiabile", value: "is_rentable" },
        { text: "Ingombrante", value: "is_cumbersome" },
      ],
      filters: [
        { label: "Noleggiabile", name: "is_rentable", type: "boolean" },
        { label: "Ingombrante", name: "is_cumbersome", type: "boolean" },
      ],
    }
  },
}
</script>
